import { render } from "./AvatarStack.vue?vue&type=template&id=f7cc9c54&scoped=true"
import script from "./AvatarStack.vue?vue&type=script&lang=js"
export * from "./AvatarStack.vue?vue&type=script&lang=js"

import "./AvatarStack.vue?vue&type=style&index=0&id=f7cc9c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7cc9c54"]])

export default __exports__